module.exports = __webpack_public_path__ + "img/discover-card-ico.0635185a.jpg";